export { default as LogoEpos } from './logo-epos.svg';
